import { useEffect } from 'react';
import { TruckIcon, StoreIcon } from '@grupoboticario/flora-react-icons';
import { cart, user } from 'core';
import { RadioCard, RadioGroup, ShippingModelOption } from 'ui/components';
import { useBusinessUnit } from './useBusinessUnit';

const ShippingModelOptionsWidget = () => {
  const { shippingModelReseller, shippingModelPickupStore, distributionCenterDefaultCode } =
    useBusinessUnit();
  const { shippingModelType } = cart.hooks.useCartShippingModel();
  const { setBusinessModel } = cart.commands.useCartCommand();
  const {
    data: { fullAddress = '' },
  } = user.hooks.useUser();
  const defaultModelCode = `delivery-${shippingModelReseller?.code}`;
  const addressAvailable = shippingModelPickupStore?.deliveries.length;

  const handleShippingModel = (event: string) =>
    setBusinessModel(
      event.includes('delivery')
        ? { shippingModelType: defaultModelCode, distributionCenterDefaultCode }
        : { shippingModelType: event.toString() },
    );

  useEffect(() => {
    setBusinessModel({ shippingModelType: defaultModelCode, distributionCenterDefaultCode });
  }, []);

  return (
    <RadioGroup
      data-testid="shipping-model-options"
      name="shipping-model-options"
      onChange={handleShippingModel}
      value={shippingModelType || defaultModelCode}
    >
      <RadioCard
        key={`delivery-${shippingModelReseller?.code}`}
        value={`delivery-${shippingModelReseller?.code}`}
      >
        <ShippingModelOption
          description={fullAddress}
          icon={<TruckIcon size={24} />}
          title="Receber no endereço cadastrado"
        />
      </RadioCard>
      {addressAvailable ? (
        <RadioCard
          key={`pickupStore-${shippingModelPickupStore?.code}`}
          value={`pickupStore-${shippingModelPickupStore?.code}`}
        >
          <ShippingModelOption
            description="Selecione qual na próxima etapa"
            icon={<StoreIcon size={24} />}
            title="Retirar no Espaço Representante"
          />
        </RadioCard>
      ) : (
        <></>
      )}
    </RadioGroup>
  );
};

export default ShippingModelOptionsWidget;
